// This is an auto-generated file from svgr lib;
// PLEASE DO NOT CHANGE THIS FILE MANUALLY;
import React from "react";

const Pix = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 27 27" fill="none" width="1em" height="1em" {...props}>
      <path
        d="M21.2175 20.0931C20.1869 20.0931 19.2178 19.6918 18.4891 18.9635L14.5495 15.024C14.273 14.7466 13.7909 14.7475 13.5144 15.024L9.56043 18.9779C8.83168 19.7062 7.86253 20.1074 6.83198 20.1074H6.05566L11.0451 25.097C12.6034 26.6552 15.1299 26.6552 16.6882 25.097L21.6921 20.0931H21.2175Z"
        fill="currentColor"
      />
      <path
        d="M6.83185 6.15824C7.86241 6.15824 8.83156 6.55961 9.56019 7.28799L13.5141 11.2426C13.7989 11.5273 14.2639 11.5286 14.5494 11.2422L18.4889 7.30232C19.2176 6.57394 20.1868 6.17269 21.2173 6.17269H21.6918L16.6881 1.16891C15.1298 -0.389392 12.6033 -0.389392 11.045 1.16891L6.05566 6.15824H6.83185Z"
        fill="currentColor"
      />
      <path
        d="M25.8313 10.3119L22.8074 7.28811C22.7408 7.31479 22.6688 7.33147 22.5927 7.33147H21.218C20.5072 7.33147 19.8114 7.61968 19.3092 8.12223L15.3696 12.0619C15.0011 12.4305 14.5167 12.6151 14.0327 12.6151C13.5483 12.6151 13.0643 12.4305 12.6956 12.0622L8.74129 8.1079C8.23899 7.60535 7.54335 7.31714 6.83251 7.31714H5.14202C5.07 7.31714 5.00254 7.30009 4.93892 7.27612L1.9031 10.3119C0.344799 11.8701 0.344799 14.3966 1.9031 15.955L4.9388 18.9907C5.00242 18.9668 5.07 18.9497 5.14202 18.9497H6.83251C7.54335 18.9497 8.23899 18.6615 8.74129 18.1589L12.6952 14.205C13.4099 13.4909 14.6557 13.4906 15.3696 14.2054L19.3092 18.1445C19.8114 18.6472 20.5072 18.9354 21.218 18.9354H22.5927C22.6689 18.9354 22.7408 18.9519 22.8076 18.9786L25.8313 15.955C27.3896 14.3966 27.3896 11.8701 25.8313 10.3119Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Pix;
